import { useMutation } from "@tanstack/react-query";
import { post } from "api/api-methods";
import { useBookingId } from "hooks/use-booking-id";
import { trackEvent } from "logger/logger";
import { pageTrackingService, TRACKING_VERSION } from "logger/page-tracking";

export const useRefreshBooking = () => {
    const bookingId = useBookingId();

    const refreshBooking = async () => {
        if (!bookingId) return;

        const startTime = new Date().getTime();

        try {
            await post(`WebBooking/WebBookings/${bookingId}/Refresh`, {});

            const endTime = new Date().getTime();
            const loadTime = endTime - startTime;
            const pageContext = pageTrackingService.getCurrentContext();

            // Track booking refresh success
            trackEvent("Booking.Refreshed.Success", {
                bookingId,
                sessionId: pageContext.sessionId,
                durationMs: loadTime,
                trackingVersion: TRACKING_VERSION,
            });
        } catch (error) {
            const endTime = new Date().getTime();
            const loadTime = endTime - startTime;
            const pageContext = pageTrackingService.getCurrentContext();

            // Track booking refresh failure
            trackEvent("Booking.Refreshed.Failure", {
                bookingId,
                sessionId: pageContext.sessionId,
                durationMs: loadTime,
                errorMessage: error instanceof Error ? error.message : "Unknown error",
                trackingVersion: TRACKING_VERSION,
            });

            throw error;
        }
    };

    return useMutation({
        mutationFn: refreshBooking,
        scope: {
            id: "webbooking-create",
        },
    });
};
